// TODO: find a better way to do this and future proof for internationalization
// checkout is also searching for a solution to the internationalization problem

import DateTimeFormatCache from '../utils/dateTimeFormatCache';

const timeFormatterCache = new DateTimeFormatCache({
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'UTC'
});

/* eslint-disable complexity */
function convertToTwelveHourTime(time) {
    if (!time) {
        return null;
    }

    const parts = time.split(':');
    let hours = Number(parts[0]);
    const min = parts[1];

    const isInvalidTime =
        parts.length !== 2 ||
        isNaN(hours) ||
        time.toLowerCase().indexOf('am') > -1 ||
        time.toLowerCase().indexOf('pm') > -1;

    if (isInvalidTime) {
        return time;
    }

    if (hours === 0) {
        return `12:${min} AM`;
    }

    if (hours === 12) {
        return `${hours}:${min} PM`;
    }

    if (hours > 12) {
        hours = hours - 12;

        return `${hours}:${min} PM`;
    }

    return `${hours}:${min} AM`;
}

function parseTime(timeString) {
    // parses time strings like '1:00 pm','1:00 am.','1:00 p','1:00pm','1:00a.m.','1:00p','1 am'
    let time = timeString.match(/(\d+)(:(\d\d))?\s*(p?)(a?)/i);
    if (!time) {
        return null;
    }

    let hours = parseInt(time[1], 10);
    if (!!time[4] || !!time[5]) {
        if (hours === 12 && !time[4]) {
            hours = 0;
        } else {
            hours += hours < 12 && time[4] ? 12 : 0;
        }
    }
    return new Date(Date.UTC(0, 0, 0, hours, parseInt(time[3], 10) || 0, 0));
}

function convertToLocaleTimeString(timeString, locale = 'en-US') {
    if (!timeString) {
        return null;
    }
    if (typeof timeString !== 'string') {
        return timeString;
    }
    const date = parseTime(timeString);
    if (!date) {
        return timeString;
    }

    const formatter = timeFormatterCache.getFormatter(locale);
    return formatter.format(date);
}

export {convertToTwelveHourTime, convertToLocaleTimeString};
